module.exports = __webpack_public_path__ + "static/media/sachic.0c76085d.png";